import { configureStore, combineReducers } from '@reduxjs/toolkit'
import productReducer from './slices/product-slice'
import currencyReducer from './slices/currency-slice'
import cartReducer from './slices/cart-slice'
import compareReducer from './slices/compare-slice'
import wishlistReducer from './slices/wishlist-slice'

export const rootReducer = combineReducers({
  product: productReducer,
  currency: currencyReducer,
  cart: cartReducer,
  compare: compareReducer,
  wishlist: wishlistReducer,
})

export const store = configureStore({
  reducer: rootReducer
})
